// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__q89a2","load3":"Loader_load3__1WVIU"};